import {rules as v} from '../scripts/rules';

const probenliste = {
	"Probennr"    : v.isNum,
	"Schnittnr"   : v.isNum,
	"Planumsnr"   : v.isNumManyWithoutDash,
	"Profilnr"    : v.isNumManyWithoutDash,
	"Befundnr"    : v.isNumManywithDash,
	"Probenart"   : v.ProbenThes,
	"Bemerkung"   : v.isFreetext,
	"Fotonr"      : v.isNumManyWithoutDash,
	"Datum"       : v.isDate,
	"BearbeiterIn": v.isFreetextNotEmpty
}

export default probenliste;
